import BossModel from "@/models/BossModel";
import Element from "@/models/PlatinumPage/Version/Element/Element";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Container extends BossModel {

    static apiUrl = 'platinum-page/version/container';

    static entity = 'platinumPageVersionContainers';

    static fields() {
        return {
            id: this.number(null).nullable(),
            background_public_image_id: this.number(null).nullable(),
            rank: this.number(null).nullable(),
            platinum_page_version_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            has_gutters: this.boolean(true),
            display_type: this.attr(null),
            content_width: this.attr(null),
            background_public_image_x_position: this.number(null).nullable(),
            background_public_image_y_position: this.number(null).nullable(),
            is_parallax: this.boolean(false),
            image_opacity: this.number(null).nullable(),
            elements: this.hasMany(Element, 'platinum_page_version_container_id'),
            publicImage: this.belongsTo(PublicImage, 'background_public_image_id'),
        }
    }

    static getSelected() {
        return this.all().filter(item => item.copy_selected);
    }

    static updateElementRanks(container, rows) {
        for (let key in rows) {
            if (Object.prototype.hasOwnProperty.call(rows, key) && rows[key].id !== undefined) {
                rows[key].rank = key;
                rows[key].platinum_page_version_container_id = container.id;
                rows[key].platinum_page_version_element_row_column_id = null;
                rows[key].api().update();
            }
        }
    }

    Elements() {
        return this.getRelated('elements');
    }
}
